module.exports = __webpack_public_path__ + "img/bi.129dc7fc.svg";